export const tiltOptions = {
  max: 30,
  perspective: 300,
  reverse: true,
  scale: 1
};

export const logosExpertise = ['js', 'react', 'gatsby', 'git', 'webpack', 'graphql'];